import MuiSearchOutlined from '@mui/icons-material/SearchOutlined';
import { SvgIconProps } from '@mui/material/SvgIcon';

export type SearchOutlinedProps = SvgIconProps;

export const SearchOutlined = (props: SearchOutlinedProps) => {
  return <MuiSearchOutlined {...props} />;
};
